import React from 'react';
import styled from 'styled-components/native';

const ImageWrapper = styled.View<{
  width?: string;
  height?: string;
}>`
  justify-content: center;
  align-items: center;
  width: ${(p) => (p.width ? p.width : `48px`)};
  height: ${(p) => (p.height ? p.height : `48px`)};
`;

const StyledImage = styled.Image`
  width: 100%;
  height: 100%;
`;

export const LoyaltyLogo = ({
  uri,
  width,
  height,
}: {
  uri: string;
  width?: string;
  height?: string;
}) => {
  return (
    <ImageWrapper width={width} height={height}>
      <StyledImage source={{ uri }} />
    </ImageWrapper>
  );
};
